import React, { useState } from 'react';
import './Gallery.css';

const HERO_IMG = '/inside1.png';

const photos = [
  { src: '/inside1.png', alt: 'Restaurant dining room', size: 'wide' },
  { src: '/inside2.png', alt: 'Restaurant booths', size: 'normal' },
  { src: '/inside3.png', alt: 'Restaurant interior', size: 'normal' },
  { src: '/food1.png', alt: 'Italian dishes', size: 'tall' },
  { src: '/food2.png', alt: 'Italian food spread', size: 'normal' },
  { src: '/food3.png', alt: 'Chicken dish', size: 'normal' },
];

const testimonials = [
  {
    name: 'Maria T.',
    stars: 5,
    text: 'The best Italian food in Chesterfield, hands down! The pasta is made fresh daily and you can truly taste the difference. We\'ve been coming here for over 10 years.',
  },
  {
    name: 'James K.',
    stars: 5,
    text: 'Giuseppe\'s hosted our company\'s holiday dinner and everything was absolutely perfect. The staff was incredibly attentive and the food was outstanding.',
  },
  {
    name: 'Linda M.',
    stars: 5,
    text: 'Authentic Italian flavors that remind me of my grandmother\'s cooking. The tiramisu is divine and the portions are generous. A hidden gem in Michigan!',
  },
  {
    name: 'Robert S.',
    stars: 5,
    text: 'We celebrated our anniversary here and had the most wonderful evening. The atmosphere is romantic, the service impeccable, and the food — extraordinary.',
  },
  {
    name: 'Angela P.',
    stars: 5,
    text: 'I\'ve tried Italian restaurants all across Michigan and nothing compares to Giuseppe\'s. The veal marsala melts in your mouth and the bruschetta is addictive!',
  },
  {
    name: 'David H.',
    stars: 5,
    text: 'Used Giuseppe\'s for catering our wedding reception and received so many compliments from our guests. Professional, delicious, and stress-free.',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <main>
      <div className="page-hero">
        <img src={HERO_IMG} alt="Restaurant gallery" />
        <div className="page-hero-content">
          <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '1rem', letterSpacing: '0.2em', color: 'var(--gold-pale)', marginBottom: '0.5rem' }}>A Visual Journey</p>
          <h1>Gallery &<br /><em style={{ fontSize: '0.8em' }}>Testimonials</em></h1>
          <a href="tel:5869484900" className="phone-link">586-948-4900</a>
        </div>
      </div>

      <div className="gold-bar" />

      {/* Photo Grid */}
      <section className="section gallery-section">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>Inside Giuseppe's</h2>
          <div className="divider-ornament" style={{ margin: '1rem auto 3rem' }}><span>✦</span></div>
          <div className="photo-grid">
            {photos.map((photo, i) => (
              <div
                key={i}
                className={`photo-grid__item photo-grid__item--${photo.size}`}
                onClick={() => setLightbox(photo)}
              >
                <img src={photo.src} alt={photo.alt} loading="lazy" />
                <div className="photo-grid__overlay">
                  <span>View</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox__close" onClick={() => setLightbox(null)}>✕</button>
          <img src={lightbox.src.replace('w=700', 'w=1200')} alt={lightbox.alt} onClick={e => e.stopPropagation()} />
        </div>
      )}

      {/* Testimonials */}
      <section className="section testimonials-section">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>What Our Guests Say</h2>
          <div className="divider-ornament" style={{ margin: '1rem auto 3rem' }}><span>✦</span></div>
          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <div className="testimonial-card" key={i}>
                <div className="testimonial-card__stars">
                  {'★'.repeat(t.stars)}
                </div>
                <p className="testimonial-card__text">"{t.text}"</p>
                <p className="testimonial-card__name">— {t.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
